<div class="detail-page">
  <button type="button" (click)="goBack()" class="back-link" title="Back to companies" aria-label="Back to companies">
    <span class="material-icons">arrow_back</span>
  </button>

  @if (isLoading()) {
    <p class="hint">Loading...</p>
  } @else if (notFound()) {
    <app-empty-state message="This company doesn't exist." />
  } @else {
    <app-error-banner [message]="errorMessage()" />

    @if (company(); as c) {
      <div class="detail-header">
        <div class="detail-header__top">
          <h1>{{ c.name }}</h1>
          <app-status-badge [status]="c.status" />
        </div>

        <div class="info-grid">
          <div class="info-item">
            <span class="label">Registration No.</span>
            <span class="value">{{ c.registrationNo }}</span>
          </div>
          <div class="info-item">
            <span class="label">Country</span>
            <span class="value">{{ c.countryCode }}</span>
          </div>
          <div class="info-item">
            <span class="label">Contact email</span>
            <span class="value">{{ c.contactEmail }}</span>
          </div>
          <div class="info-item">
            <span class="label">Contact phone</span>
            <span class="value">{{ c.contactPhone || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Address</span>
            <span class="value">{{ c.address || '—' }}</span>
          </div>
          <div class="info-item">
            <span class="label">Registered</span>
            <span class="value">{{ c.createdAt | date: 'medium' }}</span>
          </div>
          @if (c.approvedAt) {
            <div class="info-item">
              <span class="label">Approved</span>
              <span class="value">{{ c.approvedAt | date: 'medium' }}</span>
            </div>
          }
          @if (c.rejectionReason) {
            <div class="info-item">
              <span class="label">Rejection reason</span>
              <span class="value">{{ c.rejectionReason }}</span>
            </div>
          }
          @if (c.suspensionReason) {
            <div class="info-item">
              <span class="label">Suspension reason</span>
              <span class="value">{{ c.suspensionReason }}</span>
            </div>
          }
        </div>
      </div>

      @if (canTopUpWallet) {
        <button class="top-up-btn" (click)="openTopUpDialog()">Top up wallet</button>
      }

      <section class="users-section">
        <h2>Users</h2>

        @if (users().length === 0) {
          <app-empty-state message="No users yet." />
        } @else {
          <table>
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Role</th>
                <th>Status</th>
                <th>Last login</th>
                @if (canManageUsers) {
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              @for (user of users(); track user.id) {
                <tr [class.row-locked]="isCompanyLocked" [title]="toggleTooltip">
                  <td>{{ user.email }}</td>
                  <td>{{ user.fullName }}</td>
                  <td>
                    <span class="role-cell">
                      {{ user.role }}
                      @if (canManageUsers) {
                        <button class="edit-role-btn" (click)="openChangeRoleDialog(user)" aria-label="Change role" title="Change role">
                          <svg class="edit-pen-icon" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                            <path class="edit-pen-icon__pen" d="M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" />
                            <line class="edit-pen-icon__underline" x1="4" y1="21.5" x2="9.5" y2="21.5" />
                          </svg>
                        </button>
                      }
                    </span>
                  </td>
                  <td><app-status-badge [status]="user.enabled ? 'ACTIVE' : 'SUSPENDED'" [label]="user.enabled ? 'Enabled' : 'Disabled'" /></td>
                  <td>{{ user.lastLoginAt ? (user.lastLoginAt | date: 'medium') : 'Never' }}</td>
                  @if (canManageUsers) {
                    <td>
                      <button
                        class="link-btn"
                        [class.link-btn--danger]="user.enabled"
                        (click)="toggleUser(user)"
                        [disabled]="togglingUserId() === user.id || isCompanyLocked"
                        [title]="toggleTooltip"
                      >
                        {{ user.enabled ? 'Disable' : 'Enable' }}
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        }
      </section>
    }
  }
</div>
